<nz-layout>
  <nz-sider
    #sider
    id="nzSider"
    nzCollapsible
    [nzWidth]="SIDEBAR_WIDTH + 'px'"
    nzCollapsedWidth="56"
    (nzCollapsedChange)="sidebarChanged($event)"
  >
    <nz-affix class="menu-sidebar" [class.collapsed]="sider.nzCollapsed" [nzOffsetTop]="0">
      <ng-container *ngIf="WorkersData.XencioIcon === 'show'; else NoImgTemplate">
        <div class="sidebar-logo" routerLink="/">
          <img
            [class]="sider.nzCollapsed ? 'small' : 'white'"
            [src]="
              'assets/img/logo-' +
              (sider.nzCollapsed ? 'small' : 'white') +
              (WorkersData.openBy === 'Xencio' ? '' : '-' + WorkersData.openBy) +
              '.png'
            "
            alt="logo"
          />
        </div>
      </ng-container>

      <ng-template #NoImgTemplate> </ng-template>
      <router-outlet name="menu"></router-outlet>
    </nz-affix>
  </nz-sider>

  <nz-layout class="right-layout" [class.collapsed]="sider.nzCollapsed">
    <nz-header class="right-header" [class.collapsed]="sider.nzCollapsed" style="color: #8c8c8c">
      <router-outlet name="top"></router-outlet>
    </nz-header>
    <nz-content [class.tutorial_content]="videoTutorial">
      <layout-watermark></layout-watermark>
      <div>
        <router-outlet name="titleTop"></router-outlet>
        <div class="right-content-title" [class.content_title_hide]="hideContentTitle" nz-row nzJustify="space-between">
          <ng-container *ngIf="showMoveBefore">
            <div class="move-alert-box">
              <nz-alert
                nzType="warning"
                class="move-alert mb-md"
                i18n-nzMessage
                [nzMessage]="massageTemp"
                nzShowIcon
              ></nz-alert>
              <ng-template #massageTemp>
                <span class="text-grey-8" i18n
                  >尊敬的{{ moveTitle }}用户：为向用户提供更优质的服务，{{ moveCus }}系统将于“{{
                    moveTime
                  }}”进行升级维护。系统升级期间，全部功能将无法使用，请您提前做好相关安排，由此给您带来的不便敬请谅解。有任何问题欢迎随时联系，感谢您的长久支持和信任！</span
                >
              </ng-template>
            </div>
          </ng-container>
          <div nz-col *ngIf="!hideContentTitle">
            <span class="text">{{ contentTitle }}</span>
          </div>
          <div nz-col nzFlex="auto" [class.width-100]="hideContentTitle">
            <div nz-row nzJustify="space-between">
              <div nz-col><router-outlet name="titleLeft"></router-outlet></div>
              <div nz-col><router-outlet name="titleRight"></router-outlet></div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-content">
        <ng-container *ngIf="!noPermission && !needBigGroup && !emptyMenu; else navigationTemp">
          <router-outlet></router-outlet>
        </ng-container>

        <ng-template #navigationTemp>
          <div class="inner-content MFlex intercept">
            <h2 class="text-grey-9 Flex font-weight-bold">欢迎使用{{ deployTitle }}</h2>
            <h3 *ngIf="emptyMenu; else menuTemp" class="Flex text-grey-7">
              您在该企业下未授权，请联系管理员配置菜单权限
            </h3>
            <ng-template #menuTemp>
              <h3 *ngIf="noPermission; else needBigGroupTemp" class="Flex text-grey-7">
                您暂无{{ contentTitle }}菜单权限，可点击左侧菜单查看其他内容
              </h3>
              <ng-template #needBigGroupTemp>
                <h3 class="Flex text-grey-7">
                  {{ contentTitle }}菜单仅支持在集团层面操作，请点击右上角切换至集团后使用该功能
                </h3>
              </ng-template>
            </ng-template>
            <img src="assets/img/intercept.png" />
          </div>
        </ng-template>
      </div>

      <!--  -->
    </nz-content>
  </nz-layout>
  <router-outlet name="cQuestion"></router-outlet>
  <router-outlet name="guide"></router-outlet>
</nz-layout>
